import gbAntTableMultiple from "./src/gb-ant-table-multiple.vue";
const gbAntTableMultipleCompenet = function(Vue) {
  Vue.component(gbAntTableMultiple.name, gbAntTableMultiple);
};
export default gbAntTableMultipleCompenet;
